import { cn } from '@/lib/cn'

type CardProps = {
  children: React.ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  variant?: 'solid' | 'muted'
}

const paddingStyles = {
  none: 'p-0',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
} as const

const variantStyles = {
  solid: 'card',
  muted: 'card-muted',
} as const

export function Card({ children, className, padding = 'md', variant = 'solid' }: CardProps) {
  return <div className={cn(variantStyles[variant], paddingStyles[padding], className)}>{children}</div>
}
